import { BoostSearchProvider } from '../platforms/boost/BoostSearchProvider';
import AppConfig from '../config/config';
export const providerMap = {
    boost: BoostSearchProvider,
};
export function getSearchProvider() {
    switch (AppConfig.provider) {
        case 'boost':
            return new BoostSearchProvider();
        default:
            throw new Error(`Unsupported provider: ${AppConfig.provider}`);
    }
}
